import React from 'react'
import { useDispatch } from 'react-redux'
import { withRouter } from 'react-router-dom'

//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import ValidatePinCodeModal, { PIN_CODE_MODAL } from 'shared/Modals/ValidatePinCodeModal'

import { validationPinCodeFetcher } from '../constants'
import { translateLKMessage } from '../helpers'
import { validatePinCode } from 'src/store/client'
import { AppDispatch } from 'src/store/index.d'

const Modals = ({ match, onConfirm }) => {
  const dispatch = useDispatch<AppDispatch>()

  async function handleConfirm(code) {
    const { ID, hash } = match.params
    // dispatch(
    //   fetchSFM({
    //     instanceName: validationPinCodeFetcher,
    //     callApi: Client.validatePinCode,
    //     callApiArgs: [ID, hash, code],
    //     resolve: (response) => {
    //       if (response.Data) {
    //         dispatch(LKModalActions.openInfo('Success'))
    //       } else {
    //         dispatch(LKModalActions.openError('Incorrect'))
    //       }

    //       if (typeof onConfirm === 'function') {
    //         onConfirm(onConfirm && response.Data ? code : '')
    //       }
    //     },

    //     reject: (error) => {
    //       dispatch(LKModalActions.openInfo(translateLKMessage(error.Error.Message || error.Error.Text)))
    //     },
    //   }),
    // )

    //UPDATED API REQUEST client_oper_api page:mclpincodevalidate
    try {
      const res = await dispatch(
        validatePinCode({
          ID,
          hash,
          code,
        }),
      )

      if (res.payload) {
        dispatch(LKModalActions.openInfo('Success'))
      } else {
        dispatch(LKModalActions.openError('Incorrect'))
      }

      if (typeof onConfirm === 'function') {
        onConfirm(onConfirm && res.payload ? code : '')
      }
    } catch (error) {
      dispatch(LKModalActions.openInfo(translateLKMessage(error?.Error?.Message || error?.Error?.Text)))
    }

    dispatch(LKModalActions.close(PIN_CODE_MODAL))
  }

  return <ValidatePinCodeModal onConfirm={handleConfirm} />
}

export default withRouter(Modals)
